import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { getCookie } from '../utils/getCookies';
import { inject } from '@angular/core';
import { environment } from '../../environments/environment';

export const userGuard: CanActivateFn = (route, state) => {
  const hasToken = !!getCookie('access_token');
  
  // if we have a token, we return true
  if (hasToken) return true;

  // if we are not in production, we return true, we can see the app without being logged in
  if (!environment.production) return true;

  const router = inject(Router);
  return router.createUrlTree(['/session/register']);
};